import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { er } from '@fullcalendar/core/internal-common';
import { SettlementsService } from 'src/app/services/settlements.service';
import { HelpService } from 'src/app/shared/services/help.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video-player',
  template: `
    <div #modalVideoPlayer id="modalVideoPlayer" class="modal fade" tabindex="-1" aria-labelledby="modalVideoPlayer" aria-hidden="true">
      <div class="modal-dialog modal-dialog-top modal-xl">        
        <div class="modal-content rounded-5 p-3">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="modalVideoPlayer">Guía de uso - Ayuda</h5>
          </div>
          <div class="modal-body text-center pb-4">
            <div class="row">
              <div class="col-7">
                <div>
                  <video id="videoPlayer" controls (click)="toggleVideo($event)" #videoPlayer width="100%;" >
                    <source [src]="videoSource" type="video/mp4" />
                    Browser not supported
                  </video>
                </div>
                <div *ngIf="!hasVideo"></div>
                <div class="row" *ngFor="let img of resources?.imgs">
                <div class="col-6">
                  <img [src]="img" width="100%" class="mt-3">
                  </div>
                </div>
              </div>
              <div class="col-5 text-start">
                <div *ngIf="resources?.resources.length > 0">
                  <h5>Ayuda en está sección</h5>
                  <ul class="text-start">
                    <li *ngFor="let resource of resources.resources" (click)="fetchSource(resource.route)" class="text-primary mt-2" style="text-decoration: underline;">{{resource.title}}</li>                
                  </ul>
                </div>
                <div *ngIf="guide">
                  <h5 class="mt-4">Guía rápida</h5>
                  <h4 class="mb-2 mt-2">{{guide?.title}}</h4>
                  <p class="mb-0" style="font-size: 15px;">{{guide?.description}}</p>
                  <ol class="ps-3" *ngIf="guide?.howto.length > 0">
                    <li class="mt-3" *ngFor="let guia of guide?.howto">{{guia}}</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class VideoPlayerComponent implements OnInit{
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef | undefined;
  @Input() profile: any;
  @Input() permissions: any;

  route: any = null;
  videoSource: string = '';
  guide: any = null;
  resources: any = null;
  apiUrl: string = environment.AWS_REST_WSPREFIX;
  hasVideo: boolean = false;
  isPlay: boolean = false;

  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    if(!this.videoplayer!.nativeElement.contains(event.target)) {
      this.videoplayer!.nativeElement.pause();
    }
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: SettlementsService,
    private router: Router,
    private renderer: Renderer2,
    private help: HelpService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let video: any = event.url.split("/");
        let newRoute: string = "";
        video.forEach((element: any) => {
          if (element != '') {
            if (Number(element)) {
              newRoute += `-show`;
            } else {
              newRoute += `-${element}`;
            }
          }
        });
        this.fetchSource(newRoute);
        this.fetchResources(newRoute);
      }
    });
  }

  ngOnInit(): void {}

  fetchSource(route: any) {
    console.log("videoplayer ==> ", this.videoplayer!.nativeElement);
    try {
      this.store.getVideo(route).subscribe({
        next: (data: any) => {
          console.log("data ==> ", data);
          this.hasVideo = true;
          this.videoSource = `${this.apiUrl}/videos/zazz${route}.mp4`;
        },
        error: (error: any) => {
          console.log("X error ==> ", error);
          if (error.status == 404) {
            this.hasVideo = false;
          } else if (error.status == 200) {
            this.hasVideo = true;
            this.videoSource = `${this.apiUrl}/videos/zazz${route}.mp4`;
            this.videoplayer!.nativeElement.load();
          }
        }
      });
    } catch (error) {
      console.log("error ==> ", error);
    }
  }

  fetchResources(newRoute: any) {
    let quickGuide = this.help.quickGuide(newRoute);
    let resources = this.help.getResources();
    console.log("quickGuide ==> ", newRoute);
    // console.log("quickGuide ==> ", quickGuide.find((el: any) => el.route == newRoute));
    // console.log('WTF ==> ', newRoute.split("-")[1]);
    this.guide = quickGuide.find((el: any) => el.route == newRoute);
    let rxs: any = resources.find((el: any) => el.name == newRoute.split("-")[1]);
    this.resources = resources.find((el: any) => el.name == newRoute.split("-")[1]);
    // console.log('resources ==> ', resources);
    // console.log('resources filter ==> ', rxs);
    let resourcs: any = [];
    // console.log('rxs ==> ', rxs);
    /*rxs.resources.forEach((element: any) => {
      let p: any = element.permission.split('.');
      // console.log('p ==> ', p);
      // console.log('permission => ', rxs);
      
      let prx: any = this.permissions.modules[rxs.module][rxs.section][element.permission];
      // console.log('permission.modules => ', prx.active);
      if (p.length == 4) {
        // console.log('IS 4');
        // // console.log('PERMISSION ==> ', this.permissions[p[0]][p[1]][p[2]][p[3]]);
        if (this.permissions[p[0]][p[1]][p[2]][p[3]] === true) {
          resourcs.push(element);
        }
      } else if (p.length == 5) {
        // console.log('IS 5 => ', this.permissions[p[0]][p[1]][p[2]][p[3]][p[4]]);
        if (this.permissions[p[0]][p[1]][p[2]][p[3]][p[4]] === true) {
          resourcs.push(element);
        }
      }
      
      // if (this.permissions.menu.indexOf(element.permission) == -1) {
        // this.resources.resources.splice(this.resources.resources.indexOf(element), 1);
      // }
    });
    // console.log('resourcs ==> ', resourcs);*/
    // console.log('this.resources ==> ', this.resources);
  }

  toggleVideo(event: any) {
    this.videoplayer!.nativeElement.play();
  }

  playPause() {
    if (this.videoplayer!.nativeElement.paused) this.videoplayer!.nativeElement.play();
    else this.videoplayer!.nativeElement.pause();
  }

  makeBig() {
    this.videoplayer!.nativeElement.width = 560;
  }

  makeSmall() {
    this.videoplayer!.nativeElement.width = 320;
  }

  makeNormal() {
    this.videoplayer!.nativeElement.width = 420;
  }

  skip(value: any) {
    this.videoplayer!.nativeElement.currentTime += value;
  }

  restart() {
    this.videoplayer!.nativeElement.currentTime = 0;
  }
}
